export const LogoMark = ({ className = "h-10 w-10" }) => (
  <svg viewBox="0 0 48 48" className={className} aria-hidden="true">
    <defs>
      <linearGradient id="lt-mark-blue" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#3D8BFF" />
        <stop offset="1" stopColor="#0050DC" />
      </linearGradient>
      <linearGradient id="lt-mark-silver" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#FFFFFF" />
        <stop offset="0.5" stopColor="#C9D1DC" />
        <stop offset="1" stopColor="#8E99AB" />
      </linearGradient>
    </defs>
    <rect x="10" y="2.5" width="28" height="43" rx="8.5" fill="url(#lt-mark-blue)" />
    <rect x="10.9" y="3.4" width="26.2" height="41.2" rx="7.6" fill="none" stroke="url(#lt-mark-silver)" strokeWidth="1.6" />
    <rect x="24.6" y="7.2" width="8.8" height="12.4" rx="3.3" fill="#05163D" fillOpacity="0.35" />
    <circle cx="29" cy="10.9" r="2.2" fill="#fff" />
    <circle cx="29" cy="10.9" r="0.9" fill="#0050DC" />
    <circle cx="29" cy="15.9" r="2.2" fill="#fff" />
    <circle cx="29" cy="15.9" r="0.9" fill="#0050DC" />
    <path d="M17.6 10.5 V36.4 H28.6" fill="none" stroke="#fff" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M32.2 32.6 a5 5 0 0 1 0 7.6" fill="none" stroke="#BFE0FF" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

export const Logo = ({ tone = "light", className = "" }) => (
  <span className={`flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
    <LogoMark />
    <span className="flex flex-col leading-none">
      <span className={`font-display text-[1.3rem] font-extrabold uppercase tracking-[0.06em] ${tone === "dark" ? "text-white" : "text-[#0A0B0E]"}`}>
        LEON<span className="text-[#0066FF]">TECH</span>
      </span>
      <span className="mt-1 hidden text-[9px] font-semibold uppercase tracking-[0.34em] text-slate-400 sm:block">Smartphone &amp; Tech</span>
    </span>
  </span>
);
